import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface ModalState {
	customizeChallan: {
		isOpen: boolean;
	};
	instituteDetailsModal: {
		isOpen: boolean;
	};
	addEquipmentModal: {
		isOpen: boolean;
	};

	addMemberModal: {
		isOpen: boolean;
	};
	committeeDetailsModal: {
		isOpen: boolean;
	};
}

const initialState: ModalState = {
	customizeChallan: {
		isOpen: false,
	},
	instituteDetailsModal: {
		isOpen: false,
	},
	addEquipmentModal: {
		isOpen: false,
	},

	addMemberModal: {
		isOpen: false,
	},
	committeeDetailsModal: {
		isOpen: false,
	},
};

const modalSlice = createSlice({
	name: "modal",
	initialState,
	reducers: {
		openModal: (state, action: PayloadAction<keyof ModalState>) => {
			state[action.payload].isOpen = true;
		},
		closeModal: (state, action: PayloadAction<keyof ModalState>) => {
			state[action.payload].isOpen = false;
		},
		// For modals that need additional data
		openModalWithData: (state, action: PayloadAction<{ modalKey: keyof ModalState; data?: unknown }>) => {
			state[action.payload.modalKey].isOpen = true;
			// Add data handling if needed
		},
	},
});

export const { openModal, closeModal, openModalWithData } = modalSlice.actions;
export default modalSlice.reducer;
